import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class AppService {
  loading$: Subject<boolean> = new Subject();
}
